import { graphql } from "react-relay";

export const AddUserMutation = graphql`
  mutation AddUserMutation($input: AddUserInput!, $connections: [ID!]!) {
    addUser(input: $input) {
      user @appendNode(connections: $connections, edgeTypeName: "UserEdge") {
        email
        id
        key
        name
        roleAssignmentPrincipal
        roleAssignments(first: 100) {
          edges {
            node {
              id
              role {
                id
                name
                permissions
              }
              target {
                __typename
                roleAssignmentTarget
                ... on RoleScope {
                  displayName
                }
                ... on AccountGroup {
                  name
                }
                ... on PolicyCollection {
                  name
                }
                ... on RepositoryConfig {
                  name
                }
                ... on Node {
                  id
                }
              }
            }
          }
        }
        username
      }
    }
  }
`;
